import { render, staticRenderFns } from "./SelfRegistry.vue?vue&type=template&id=a77b7456&scoped=true&"
import script from "./SelfRegistry.vue?vue&type=script&lang=ts&"
export * from "./SelfRegistry.vue?vue&type=script&lang=ts&"
import style0 from "./SelfRegistry.vue?vue&type=style&index=0&id=a77b7456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77b7456",
  null
  
)

export default component.exports